import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Message, OverlayPanel, SelectItem, AutoComplete } from 'primeng/primeng';
import * as _ from "lodash";

//constants
import { Constants } from '../../constants/Constants';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

@Component({
    selector: 'my-customers-autocomplete',
    templateUrl: './CustomersAutoComplete.component.html'
})
export class CustomersAutoCompleteComponent implements OnInit {

    filteredCustomers: any[];
    selectedCustomerNumbers: string[] = [];
    customers: any[] = [];
    customer: any;
    customersModel: any;
    msgs: Message[] = [];

    userInfo: ent.UserInfo;

    @ViewChild('ac') public autoComplete: AutoComplete;

    @Input() public useFullServiceCustomers: boolean = false;
    @Input() public pyPayerNumberEqualsCustomerNumber: boolean = false;
    @Input() public salesOfficeIDs: number[];
    @Input() public salesOfficeID: number;
    @Input() public placeholder: string;
    @Input() public multiple: boolean;
    @Input() public disabled: boolean;
    @Input() public selectedCustomer: ent.Customer;
    @Input() public distributionChannel: string;
    @Input() public accountGroup: string;
    @Input() public accountGroupNotEqual: string;
    @Output() onSelectedCustomerNumbersChanged = new EventEmitter<string[]>();
    @Output() noMatchesFound = new EventEmitter();

    constructor(private authenticationService: serv.AuthenticationService, private customerService: serv.CustomerService) {
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();

    }

    filterCustomers(event: any, take: number): void {
        if (this.useFullServiceCustomers) {
            var filter: filters.CustomerFilter = { ZQCustomerNameOrNumberLike: event.query, Take: take };

            filter.IncludeZQCustomerRecordsOnly = true;
            filter.SalesOfficeID = this.salesOfficeID;
            filter.SalesOfficeIDs = this.salesOfficeIDs;
            this.customerService.getFullServiceCustomers(filter).subscribe(x => {
                this.filteredCustomers = []
                for (var customer of x) {
                    this.filteredCustomers.push({ name: customer.ZQFullName, ID: customer.ZQCustomerNumber });
                }
                if (x.length == 0) {
                    this.noMatchesFound.emit();
                }
            });
        }
        else {
            var filter: filters.CustomerFilter = { CustomerNameOrNumberLike: event.query, Take: take, 
                PYPayerNumberEqualsCustomerNumber: this.pyPayerNumberEqualsCustomerNumber };
            if (this.accountGroup && this.accountGroup != "") {
                filter.AccountGroup = this.accountGroup;
            }
            if (this.distributionChannel && this.distributionChannel != "") {
                filter.DistributionChannels = [this.distributionChannel];
            }
            if (this.accountGroupNotEqual && this.accountGroupNotEqual != "") {
                filter.AccountGroupNotEqual = this.accountGroupNotEqual;
            }
            this.customerService.getCustomers(filter).subscribe(x => {
                this.filteredCustomers = []
                for (var customer of x) {
                    this.filteredCustomers.push({ name: customer.FullName, ID: customer.CustomerNumber });
                }
                if (x.length == 0) {
                    this.noMatchesFound.emit();
                }
            });
        }


    }


    onCustomerSelected(selectedItem: any): void {
        this.selectedCustomerNumbers.push(selectedItem.ID);
        this.onSelectedCustomerNumbersChanged.emit(this.selectedCustomerNumbers);
        //this.customersModel = {name: selectedItem.name, ID: selectedItem.ID};
        //this.onFocused(null);
    }

    onCustomerUnselected(selectedItem: any): void {

        _.remove(this.selectedCustomerNumbers, x => x == selectedItem.ID);
        this.onSelectedCustomerNumbersChanged.emit(this.selectedCustomerNumbers);
    }

    onClearClick(event: any) {

        this.clear();
    }

    clear() {
        this.customers = [];
        this.customer = new ent.Customer();
        if (this.multiple) {
            this.customersModel = this.customers;
        }
        else {
            this.customersModel = this.customer;
        }
        this.selectedCustomerNumbers = [];
        this.selectedCustomer = {};
        this.onSelectedCustomerNumbersChanged.emit(this.selectedCustomerNumbers);
    }

    onFocused(event: any) {

        if (this.selectedCustomer && this.selectedCustomer.FullName) {
            this.customersModel = { name: this.selectedCustomer.FullName, ID: this.selectedCustomer.CustomerNumber };
        }

    }

}